/* tslint:disable */
/* eslint-disable */
/**
 * noco-server
 * noco-server
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function BulkMoveFolderDocumentsRequestFromJSON(json) {
    return BulkMoveFolderDocumentsRequestFromJSONTyped(json, false);
}
export function BulkMoveFolderDocumentsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        ids: json['ids'],
        folderId: json['folder_id']
    };
}
export function BulkMoveFolderDocumentsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        ids: value.ids,
        folder_id: value.folderId
    };
}
